export const agenciesKeys = {
  all: ['agencies'] as const,
  list: (...args: unknown[]) => [...agenciesKeys.all, 'list', ...args] as const,
  item: (id: string) => [...agenciesKeys.all, 'item', id] as const,
};
